import { createStore, getActionIds } from '../helpers/redux';
import Immutable, { Map } from 'immutable';

import { ProjectActions } from '../actions/project';
import { PageActions } from '../actions/page';


import { currentPageIdSelector } from './projectTabs';
import {
  currentElementIdSelector,
} from './elements';

const projectActions = getActionIds(ProjectActions);
const pageActions = getActionIds(PageActions);

const initialState = Immutable.fromJS({
  element: {
    0: {
      properties: false,
      producesFor: true,
      consumesFrom: true,
      children: false,
      parent: false,
      customProperties: false
    }
  }
});

export const pages = createStore(initialState, {
  [projectActions.resetReducers]: (state, action) => {
    return initialState;
  },

  [pageActions.toggleState]: (state, action) => {
    return state.mergeDeep({
      [action.reducerType]: {
        [action.elementId]: {
          [action.key]: !action.currentState,
        }
      }
    })
  },

  [pageActions.setReportHistoryViewState]: (state, action) => {
    return state.mergeDeep({
      [action.reducerType]: {
        [action.elementId]: {
          [action.key]: action.currentState
        }
      }
    })
  }
});

export const collapseStateSelector = (state) => {
  const currentPageId = currentPageIdSelector(state);
  return state.pages.getIn(['report', currentPageId], Map());
};

export const reportHistoryIdSelector = (state) => {
  const currentPageId = currentPageIdSelector(state);
  return state.pages.getIn(['report', currentPageId, 'reportHistoryId'], 0);
};

export const elementCollapseStateSelector = (state, props) =>
  state.pages.getIn(['element', currentElementIdSelector(state, props)], Map());



// WEBPACK FOOTER //
// ./src/reducers/pages.js